// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { PriceType } from '@shared/utils/History/CashItemUtils';
import { iBuildInIndicator } from '../../iBuildInIndicator';
export const iMomEx = 'iMomEx';
export class IMomEx extends iBuildInIndicator {
    constructor(momPeriod, priceType) {
        super(1);
        this.FPriceType = priceType !== null && priceType !== void 0 ? priceType : PriceType.Close;
        this.FMomPeriod = momPeriod;
    }
    get Name() {
        return iMomEx;
    }
    get Key() {
        return this.DefaultKey + this.FMomPeriod + this.FPriceType;
    }
    OnQuote() {
        const Parent = this.Parent;
        if (Parent != null || this.FCount > this.FMomPeriod) {
            this.SetValue((this.GetPrice(this.FPriceType, 0) * 100) / this.GetPrice(this.FPriceType, this.FMomPeriod));
        }
    }
}
export const iMom = 'iMom';
export class IMom extends IMomEx {
    get Name() {
        return iMom;
    }
}
